import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { concatClassName } from '@dateam/ark-react';
import { useNavigation, withRouter } from 'shared-utils';
import {
    Card,
    Loader,
    Table,
    TableRowClickEvent
} from 'shared-ui';
import { useBindYearNavigation } from 'utils/yearStore';
import config from 'config';
import Page from 'components/Page';
import ListSection from 'components/ListSection';
import { useBioTypeSearch, useVarietalTypeSearch } from 'data/effects';
import { BioTypeDetailsNavigation, VarietalTypeNavigation } from 'screens/routes';
import { FilterBar, HeaderAction, BioTypeFilter } from './components';
import BioTypeBreadcrumb from './BioTypeBreadcrumb';
import styles from './BioTypeScreen.module.scss';

const BioTypeScreen: React.FC = () => {
    useBindYearNavigation(VarietalTypeNavigation, []);
    const { t } = useTranslation();
    const { push: navigate } = useNavigation();
    const [filter, setFilter] = React.useState<BioTypeFilter>({ label: '' });
    const { data: bioTypes, isLoading } = useBioTypeSearch({ label: filter.label });

    const handleRowClick = React.useCallback((event: TableRowClickEvent<App.BioType>) => {
        navigate(BioTypeDetailsNavigation(event.data.id));
    }, [navigate]);

    const handleFilterChange = React.useCallback((filter: BioTypeFilter) => {
        setFilter(filter);
    }, [setFilter]);

    return (
        <>
            <Helmet>
                <title>{t('bioType.pageTitle', { appName: config.appName })}</title>
            </Helmet>
            <Page>
                <Page.Header>
                    <Page.Title>
                        Types de protection
                    </Page.Title>
                    <Page.HeaderActions>
                        <BioTypeBreadcrumb />
                    </Page.HeaderActions>
                </Page.Header>
                <Page.Content className="row">
                    <Card className="col">
                        <Card.Header className={concatClassName('withAction')}>
                            <Card.Title>
                                Liste des types de protection
                            </Card.Title>
                            <HeaderAction />
                        </Card.Header>
                        <Card.Body className="row">
                            {isLoading && (
                                <Loader text="chargement" />
                            )}
                            <ListSection>
                                <ListSection.Filter>
                                    <FilterBar onChange={handleFilterChange} />
                                </ListSection.Filter>
                                <ListSection.Content>
                                    <Table<App.BioType>
                                        data={bioTypes ?? []}
                                        onRowClick={handleRowClick}
                                        className={styles['tableRow']}
                                    >
                                        <Table.Column accessor="label">
                                            <Table.Column.Header>Nom</Table.Column.Header>
                                        </Table.Column>
                                    </Table>
                                </ListSection.Content>
                            </ListSection>
                        </Card.Body>
                    </Card>
                </Page.Content>
            </Page>
        </>
    );
};

export default withRouter(BioTypeScreen, 'BIOTYP');